/**
 * @function formatScoreHealth
 * @param {object} healthObj - object with health features of a property
 * @param {string} attribute - feature included in healthObj
 * @returns {string} - string formatted according to the type of attribute
 */
export const formatScoreHealth = (healthObj, attribute) => {
  const health = healthObj.adHealt
  if (attribute === 'adScore') {
    return `${healthObj[attribute] / 10}/10`
  }
  if (attribute === 'numImages') {
    return `${health[attribute]}/${health['minNumImages']}`
  }
  if (attribute === 'lengthTitle') {
    return `${health[attribute]}`
  }
  if (attribute === 'lengthDescription') {
    return `${health[attribute]}`
  }
  if (attribute === 'enableLocation') {
    return parseInt(`${health[attribute]}`) ? 'Activada' : 'Desactivada'
  }
}

/**
 * @function progressHealth
 * @param {object} healthObj - object with health features of a property
 * @param {string} attribute - feature included in healthObj
 * @returns {number} - progress of each feature
 */
export const progressHealth = (healthObj, attribute) => {
  const health = healthObj.adHealt
  if (attribute === 'adScore') {
    return parseInt(healthObj[attribute])
  }
  if (attribute === 'numImages') {
    return parseInt(health[attribute]) < parseInt(health['minNumImages'])
      ? parseInt((health[attribute] / health['minNumImages']) * 100)
      : 100
  }
  if (attribute === 'lengthTitle') {
    return parseInt(health[attribute]) < parseInt(health['minLengthTitle'])
      ? parseInt((health[attribute] / health['minLengthTitle']) * 100)
      : 100
  }
  if (attribute === 'lengthDescription') {
    return parseInt(health[attribute]) <
      parseInt(health['minLengthDescription'])
      ? parseInt((health[attribute] / health['minLengthDescription']) * 100)
      : 100
  }
  if (attribute === 'enableLocation') {
    return parseInt(`${health[attribute]}`) === 0 ? 51 : 100
  }
}

/**
 * @function progressHealth
 * @param {number} range - progress of health
 * @returns {string} - string indicating in which range the progress is located
 */
export const getConstantRange = range => {
  if (range <= 50) {
    return 'low'
  } else if (range <= 90) {
    return 'medium'
  } else {
    return 'high'
  }
}
